import { FTU_WIZARD_STEPS } from '../constants';

/**
 * Returns the FTU wizard step display order, optionally excluding the phone number step
 * based on feature flag state. This will be removed once the feature flag is retired.
 */
export const getFTUWizardStepDisplayOrder = (includePhoneStep: boolean) => {
  const allSteps = [
    FTU_WIZARD_STEPS.ORDERS,
    FTU_WIZARD_STEPS.SHIP_FROM,
    FTU_WIZARD_STEPS.CARRIER,
    FTU_WIZARD_STEPS.DISCOUNTED_RATES,
    FTU_WIZARD_STEPS.PHONE_NUMBER,
    FTU_WIZARD_STEPS.INVENTORY_SETUP,
    FTU_WIZARD_STEPS.RETURNS,
    FTU_WIZARD_STEPS.ADVANCED_OPTIONS,
  ];

  if (!includePhoneStep) {
    return allSteps.filter((step) => step !== FTU_WIZARD_STEPS.PHONE_NUMBER);
  }

  return allSteps;
};

/**
 * Returns the stepper labels, optionally excluding "Phone" based on feature flag state.
 * This will be removed once the feature flag is retired.
 */
export const getStepperLabels = (includePhoneStep: boolean) => {
  if (includePhoneStep) {
    return ['Orders', 'Ship From', 'Payments', 'Phone', 'Inventory', 'Returns'];
  }
  return ['Orders', 'Ship From', 'Payments', 'Inventory', 'Returns'];
};

/**
 * Returns the step-to-stepper mapping, adjusting indices when phone step is excluded.
 * This will be removed once the feature flag is retired.
 */
export const getFTUWizardStepToStepperMapping = (includePhoneStep: boolean) => {
  if (includePhoneStep) {
    return {
      [FTU_WIZARD_STEPS.ORDERS]: 1,
      [FTU_WIZARD_STEPS.SHIP_FROM]: 2,
      [FTU_WIZARD_STEPS.CARRIER]: 3,
      [FTU_WIZARD_STEPS.DISCOUNTED_RATES]: 3,
      [FTU_WIZARD_STEPS.PHONE_NUMBER]: 4,
      [FTU_WIZARD_STEPS.INVENTORY_SETUP]: 5,
      [FTU_WIZARD_STEPS.RETURNS]: 6,
      [FTU_WIZARD_STEPS.ADVANCED_OPTIONS]: 6,
    };
  }

  // Without phone step, inventory and returns shift down by one
  return {
    [FTU_WIZARD_STEPS.ORDERS]: 1,
    [FTU_WIZARD_STEPS.SHIP_FROM]: 2,
    [FTU_WIZARD_STEPS.CARRIER]: 3,
    [FTU_WIZARD_STEPS.DISCOUNTED_RATES]: 3,
    [FTU_WIZARD_STEPS.INVENTORY_SETUP]: 4,
    [FTU_WIZARD_STEPS.RETURNS]: 5,
    [FTU_WIZARD_STEPS.ADVANCED_OPTIONS]: 5,
  };
};
